import React, { useEffect, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import InputGeral from "../../../components/InputGeral/Index";
import { ConsultaAPI } from "../../../../backend/ConsultaAPI";
import LoadingSpinner from "../../../components/LoadinSpinner";
import ResponsiveDataTable from "../../../components/DataTable";
import ConsultaAtitudeSegura from '../../../../lib/json/consultas/AtitudeSegura.json'
import ConsultaCentroCusto from '../../../../lib/json/consultas/CentroCustoSSMA.json'
import { RetornaUsuarioLogado, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { ConsumoAPI_DELETE } from "../../../../backend/ConsumoAPI";
import { format, startOfQuarter } from "date-fns";
import { Row, Col, Button} from "react-bootstrap";
import { usePopUp } from "../../../components/BootBox";
import SelectDinamico from "../../../components/SelectDinamico";

function ListaAtitudeSegura(){
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfQuarter(currentDate);

	const usuarioLogado = RetornaUsuarioLogado();
    const [dateDe, setDateDe] = useState(format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoCentroCusto, setCampoCentroCusto] = useState({ value: '', label: 'Digite'});
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        {
            Header: 'ID',
            accessor: 'Id',
        },
        {
            Header: 'Tipo de Registro',
            accessor: 'TipoRegistro',
        },
        {
            Header: 'Empresa/Filial',
            accessor: 'FilialNome',
        },
        {
            Header: 'Centro de Custo',
            accessor: 'Descricao',
        },
        {
            Header: 'Observador',
            accessor: 'FuncionariosNome',
        },
        {
            Header: 'Data Emissão',
            accessor: 'DataHora',
        },
    ];
    
    var [carregar, setCarregar] = useState(false);
    var [filtroCentroCusto, setFiltroCentroCusto] = useState();
    var [consultaCentroCusto, setConsultaCentroCusto] = useState();
    var consultaDefault  = ConsultaAtitudeSegura.consulta;
    var [data, setData]   = useState([]);
    
    useEffect(() => {
        let consultaCC = ConsultaCentroCusto.consulta + ' WHERE 1 = 1 '
        let filtraCentroCusto = ''
        let filtraEmpresa = ''
        usuarioLogado.parametrosEmpresas.forEach((empresa) => {
            const parametroEmpresa = usuarioLogado.parametrosEmpresas.filter((e) => e.empresaFilial.substr(0, 4) === empresa.empresaFilial);
            filtraEmpresa += empresa.empresaFilial + "','";
    
            if (parametroEmpresa.length > 0) {
                if (parametroEmpresa[0].centroCusto.length > 0) {
                    filtraCentroCusto += parametroEmpresa[0].centroCusto.join("','") + "','";
                }
            }
        });

        if (filtraEmpresa)
            consultaCC += " AND '01' + LEFT(CTT_FILIAL,2) IN ('" + filtraEmpresa.slice(0,-3) + "') "
        if (filtraCentroCusto)
            consultaCC += " AND CTT_CUSTO IN ('" + filtraCentroCusto.slice(0,-3) + "') "

        setFiltroCentroCusto(filtraCentroCusto)
        setConsultaCentroCusto(consultaCC)
        // loadListaAtitudeSegura();
    },[]);

    useEffect(() => {
        if (filtroCentroCusto){
            loadListaAtitudeSegura();
        }
        else if (consultaCentroCusto && !filtroCentroCusto){
            loadListaAtitudeSegura();
        }
    },[filtroCentroCusto, consultaCentroCusto])

    // Processa consulta do grid
    const loadListaAtitudeSegura = async () => {
        setCarregar(true);
        let consultaLista = consultaDefault + ` WHERE '01' + LEFT(DSMA.FilialId,2) IN ('${usuarioLogado.empresasUsuario.join("','")}') `;

        if (dateDe){
            consultaLista += " AND DataHora >= '" + dateDe + " 00:00:00' "
        }
        
        if (dateAte){
            consultaLista += " AND DataHora <= '" + dateAte + " 23:59:59' "
        }
        
        if (campoCentroCusto.value){
            consultaLista += " AND CentroCustoId = '" + campoCentroCusto.value + "' "
        }

        if (filtroCentroCusto){
            consultaLista += " AND CentroCustoId IN ('" + filtroCentroCusto.slice(0,-3) + "') "
        }

        var retConsulta = await ConsultaAPI( consultaLista );
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.Id}`)
    }

    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.values.Id}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.values.Id;
        const Mensagem = `Tem certeza que deseja excluir o registro ${idRow + ' - Tipo Registro: ' + row.values.TipoRegistro + '/ Empresa: ' + row.values.FilialNome + ' / Centro de Custo: ' + row.values.Descricao}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(id) => {
        FechaBootBox()
        try {
            setCarregar(true);

            const rota = 'atitudeSegura/' + id;
            const retConsumo = await ConsumoAPI_DELETE(rota);

            SucessoMsg(retConsumo.description);
            loadListaAtitudeSegura();
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    };
    
    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Atitude Segura"/>
            </Col>
        </Row>
        <Row>
            <Col md="3" xs="12">
                <InputGeral
                    label="Emissão de"
                    tipo='date'
                    value={dateDe}
                    onChange={(e) => setDateDe(e.target.value)}
                />
            </Col>
            <Col md="3" xs="12">
                <InputGeral
                    label="Emissão Ate"
                    tipo='date'
                    value={dateAte}
                    onChange={(e) => setDateAte(e.target.value)}
                />
            </Col>
            <Col md="4" xs="12">
                <SelectDinamico 
                    label="Centro de Custo"
                    consulta={consultaCentroCusto}
                    tabela={ConsultaCentroCusto.tabelas}
                    cValue="CTT_CUSTO"
                    cText='CTT_CUSTO + " - " + item.CTT_DESC01'
                    isMultiplo={false}
                    campoValue={campoCentroCusto}
                    value={campoCentroCusto}
                    showNoFilter={false}
                    selectOptionUnique={true}
                    onchange={(e) => setCampoCentroCusto(e)}
                />
            </Col>
            <Col md="2" xs="12" className="d-flex justify-content-end align-items-end">
                <Button className="w-100" variant="outline-primary" type="submit" onClick={loadListaAtitudeSegura}>
                    Buscar
                </Button>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable
                        columns={columns} 
                        data={data}
                        buttons= {[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}, 
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaAtitudeSegura;